import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { Box, keyframes } from '@mui/material'
import { fsColors } from '../../../shared/constants'

const FsStepper = ({ steps, activeStep }: { steps: string[]; activeStep: number }) => {
  const BounceAnimation = keyframes`
  0% {
    transform: scale(1)
  }
  50% {
    transform: scale(1.2)
  }
  100% {
    transform: scale(1)
  }
`

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step
            key={label}
            sx={{
              '.MuiSvgIcon-root': {
                color: fsColors.fsGray.colors[2],
                fontSize: 18,
              },
              '& .MuiStepLabel-root': {
                '.MuiStepIcon-text': {
                  fill: 'none',
                },
                '.Mui-active': {
                  color: 'white',
                  '&.MuiStepLabel-alternativeLabel': {
                    color: fsColors.fsGray.colors[4],
                    fontWeight: 'bolder',
                  },
                  '.MuiStepIcon-text': {
                    fill: 'none',
                  },
                },
                '.Mui-completed': {
                  color: 'secondary.dark',
                  '.MuiSvgIcon-root': {
                    animation: `${BounceAnimation} 1s `,
                    zIndex: 1,
                  },
                },
              },
              '.MuiStepLabel-iconContainer .Mui-active': {
                borderWidth: 5,
                animation: `${BounceAnimation} 2s 1s `,
                borderRadius: '50%',
                borderStyle: 'solid',
                borderColor: fsColors.fsDarkBlue.colors[2],
                zIndex: 1,
              },
              '.MuiStepLabel-label': {
                fontSize: 12,
                marginTop: 1,
              },
              '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel': {
                color: fsColors.fsGray.colors[4],
              },
              '& .MuiStepConnector-lineHorizontal': {
                borderTopWidth: 2,
                borderColor: fsColors.fsGray.colors[2],
                mx: -1.5,
                mt: -0.55,
              },
            }}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
export default FsStepper
